import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/fastShippingCopySignedIn/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showFastShippingCopySignedInSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showFastShippingCopySignedInSelector };
